/**
 * Wraps a socket event handler in try-catch to prevent uncaught exceptions
 * from bubbling up to React's error boundary and crashing the app.
 *
 * Errors are logged with context (event name) for debugging.
 */

/* eslint-disable @typescript-eslint/no-explicit-any */

import { createLogger } from "@/utils/debug";

const log = createLogger("Socket");

export function safeSocketHandler<T extends (...args: any[]) => any>(
  eventName: string,
  handler: T,
): (...args: Parameters<T>) => void {
  return (...args: Parameters<T>) => {
    try {
      const result = handler(...args);
      if (result instanceof Promise) {
        result.catch((error: unknown) => {
          log.error(
            `Unhandled error in async handler for "${eventName}"`,
            error,
          );
        });
      }
    } catch (error) {
      log.error(`Unhandled error in handler for "${eventName}"`, error);
    }
  };
}
